export * from './PixelMilimetros.model'
